export default "__VITE_ASSET__mEKoX6l4__"